import { render, staticRenderFns } from "./FriendChild.vue?vue&type=template&id=0201f2fc&scoped=true"
import script from "./FriendChild.vue?vue&type=script&lang=js"
export * from "./FriendChild.vue?vue&type=script&lang=js"
import style0 from "./FriendChild.vue?vue&type=style&index=0&id=0201f2fc&prod&scoped=true&lang=css"
import style1 from "./FriendChild.vue?vue&type=style&index=1&id=0201f2fc&prod&lang=scss&scoped=true"
import style2 from "./FriendChild.vue?vue&type=style&index=2&id=0201f2fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201f2fc",
  null
  
)

export default component.exports